import { createReducer } from 'typesafe-actions';

import {
  DashboadConfigActionTypes,
  TDashboardConfigAction,
  IDashboardConfigState,
} from '@/store/types/dashboard-config.types';

const initialState: IDashboardConfigState = {
  isLoading: false,
};

export const dashboardConfigReducer = createReducer<IDashboardConfigState, TDashboardConfigAction>(initialState)
  .handleType(DashboadConfigActionTypes.GET_DASHBOARD_CONFIG, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_SUCCESS, (state, action) => ({
    ...state,
    config: action.config,
    isLoading: false,
    error: undefined,
  }))

  .handleType(DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }));
